/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --color: var(--nve-sys-layer-canvas-color);
  --padding: var(--nve-ref-size-200) var(--nve-ref-size-500);
  --min-height: var(--row-height);
  --min-width: var(--nve-ref-size-1000);
  --font-weight: var(--nve-ref-font-weight-medium);
  --font-size: var(--nve-ref-font-size-100);
  --height: 100%;
  --border-left: 0;
  --border-right: 0;
  --justify-content: start;
  transition: box-shadow 300ms ease-in-out;
}

[internal-host] {
  background: color-mix(
    in oklab,
    var(--background, var(--nve-sys-layer-canvas-background)) 100%,
    var(--nve-sys-interaction-state-mix) var(--interaction-state-ratio, 0.01%)
  ); /* 0.01 to prevent css optimizer from removing % type */
  color: var(--color);
  padding: var(--padding);
  height: var(--height);
  min-height: var(--min-height);
  font-size: var(--font-size);
  min-width: var(--min-width);
  border-left: var(--border-left);
  border-right: var(--border-right);
  justify-content: var(--justify-content);
  font-weight: var(--font-weight);
  display: flex;
  align-items: center;
  outline-offset: -2px;
}
